// extracted by mini-css-extract-plugin
export var fadeIn = "_kl-1";
export var modalContent = "_kl-3";
export var overlay = "_kl-0";
export var popoverContent = "_kl-2";
export var results = "_kl-5";
export var searchInputWrapper = "_kl-4";